import { Component, ContentChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-info-alert',
  standalone: false,
  templateUrl: './info-alert.component.html',
  styleUrl: './info-alert.component.scss',
})
export class InfoAlertComponent {}
